var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { utilTime } from "../../../utils/utilTime";
import { TypeActionQuestInfo } from "./actionQuestInfo";
var initial = {
    newQuestIds: [],
    quest: [],
    selectedQuest: undefined,
};
export var reducerQuestInfoReceived = function (state, action) {
    if (state === void 0) { state = initial; }
    if (action.type === TypeActionQuestInfo.Received && action.questInfo != undefined) {
        return __assign({}, state, action.questInfo, { quest: addQuestEndTime(action.questInfo.quest || []) });
    }
    else if (action.type === TypeActionQuestInfo.Update && action.questUpdate != undefined) {
        return __assign({}, state, { quest: addQuestEndTime(action.questUpdate.quest || []), selectedQuest: undefined });
    }
    else if (action.type === TypeActionQuestInfo.Finish &&
        action.questFinish != undefined &&
        action.questIds != undefined) {
        return __assign({}, state, { newQuestIds: action.questIds, quest: addQuestEndTime(action.questFinish.quest || []) });
    }
    else if (action.type === TypeActionQuestInfo.AddNewQuestIds && action.questIds != undefined) {
        return __assign({}, state, { newQuestIds: action.questIds });
    }
    else if (action.type === TypeActionQuestInfo.Skip && action.quests != undefined) {
        return __assign({}, state, { quest: addQuestEndTime(action.quests), selectedQuest: undefined });
    }
    else if (action.type === TypeActionQuestInfo.Select && action.selectedQuest != undefined) {
        return __assign({}, state, { newQuestIds: state.newQuestIds.filter(function (value) {
                return value !== action.selectedQuest.id;
            }), selectedQuest: action.selectedQuest });
    }
    else if (action.type === TypeActionQuestInfo.AddQuest && action.eventQuest != undefined) {
        var quest = state.quest.find(function (q) { return q.questId === action.eventQuest.questId; });
        if (quest) {
            return state;
        }
        return __assign({}, state, { quest: addQuestEndTime(state.quest.concat([action.eventQuest]) || []) });
    }
    else if (action.type === TypeActionQuestInfo.RemoveQuest && action.eventQuest != undefined) {
        var quest_1 = state.quest.find(function (q) { return q.questId === action.eventQuest.questId; });
        if (!quest_1) {
            return state;
        }
        return __assign({}, state, { quest: state.quest.filter(function (q) { return q.questId !== quest_1.questId; }) });
    }
    return state;
};
var addQuestEndTime = function (quest) {
    return quest.map(function (q) {
        if (q.hasRemainingTime) {
            var endTime = utilTime.timestamp(q.remainingTime);
            return __assign({}, q, { endTime: endTime });
        }
        return q;
    });
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/quest/reducerQuestInfo.ts
// module id = 2542
// module chunks = 3